/**
 * Unilar Boas-vindas / Ler mais
 * Expands and collapses rich text content with fade overlay.
 */

class BoasVindasText extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #toggle = null;
  /** @type {HTMLElement | null} */
  #content = null;
  /** @type {ResizeObserver | null} */
  #resizeObserver = null;
  #mobileMediaQuery = window.matchMedia('(max-width: 749px)');
  #boundBreakpointHandler = this.#syncState.bind(this);

  connectedCallback() {
    this.#toggle = this.querySelector('.boas-vindas-text__toggle');
    this.#content = this.querySelector('.boas-vindas-text__content');

    if (!this.#toggle || !this.#content) return;

    this.#toggle.addEventListener('click', this.#handleToggle.bind(this));
    this.#mobileMediaQuery.addEventListener('change', this.#boundBreakpointHandler);

    this.#resizeObserver = new ResizeObserver(() => this.#syncState());
    this.#resizeObserver.observe(this.#content);

    this.#syncState();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
    this.#mobileMediaQuery.removeEventListener('change', this.#boundBreakpointHandler);
  }

  #handleToggle() {
    const isExpanded = this.classList.toggle('is-expanded');
    this.#toggle.setAttribute('aria-expanded', String(isExpanded));
    this.#updateLabel(isExpanded);
  }

  #updateLabel(isExpanded) {
    const label = this.#toggle.querySelector('.boas-vindas-text__toggle-label');
    if (!label) return;

    label.textContent = isExpanded
      ? this.dataset.labelLess || 'Ler menos'
      : this.dataset.labelMore || 'Ler mais';
  }

  #getCollapsedHeight() {
    const styles = getComputedStyle(this);

    if (this.#mobileMediaQuery.matches) {
      const mobileHeight = parseInt(
        styles.getPropertyValue('--boas-vindas-collapsed-height-mobile'),
        10
      );

      if (mobileHeight) return mobileHeight;
    }

    return parseInt(styles.getPropertyValue('--boas-vindas-collapsed-height'), 10) || 180;
  }

  #syncState() {
    const collapsedHeight = this.#getCollapsedHeight();

    const needsToggle = this.#content.scrollHeight > collapsedHeight + 1;

    this.classList.toggle('is-not-collapsible', !needsToggle);

    if (needsToggle) {
      this.style.setProperty('--boas-vindas-expanded-height', `${this.#content.scrollHeight}px`);
    } else {
      this.classList.remove('is-expanded');
      this.#toggle.setAttribute('aria-expanded', 'false');
      this.#updateLabel(false);
    }
  }
}

if (!customElements.get('boas-vindas-text')) {
  customElements.define('boas-vindas-text', BoasVindasText);
}
